import { useContext, useState } from "react";
import { LocaleContext } from "../../state/LocaleContext";

export default function LoginModal({ onLogin, onClose }) {
  const { tUI } = useContext(LocaleContext);
  const labelSignIn = tUI("label_sign_in", "Sign In");
  const labelUsername = tUI("label_username", "Username");
  const labelPassword = tUI("label_password", "Password");
  const labelLogin = tUI("label_login", "Login");
  const labelLoginFailed = tUI("label_login_failed", "Login failed");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || labelLoginFailed);
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("role", data.role);
      onLogin(data.role);
      onClose();
    } catch (err) {
      setError(tUI("label_server_error", "Server error"));
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{labelSignIn}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder={labelUsername}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder={labelPassword}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button type="submit" className="btn btn-primary">
                {labelLogin}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
